import { SearchItem } from '@yiluhub/yilu-amp-types';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { paramConverters, yiluTracking } from 'utils/index';

import routes from 'router/routes';

import { PaymentInformationProps } from 'components/PaymentInformation';

import { ERROR_PRICE } from 'modules/eurail/components/EurailProductSummary';
import { getEurailProductDetails } from 'modules/eurail/utils/getProductDetails';
import { EurailPaymentInputPageQueryParams } from 'modules/eurail/utils/query-params';

export function usePaymentInfoFormProps(
  currentProduct: SearchItem | undefined,
  paymentFormRef: React.RefObject<HTMLFormElement>,
  eurailPaymentInputPageQueryParams: EurailPaymentInputPageQueryParams,
) {
  const navigate = useNavigate();

  const paymentInformationFormProps = useMemo(() => {
    if (!currentProduct) {
      return null;
    }

    const productDetails = getEurailProductDetails(currentProduct);

    const _props: PaymentInformationProps = {
      ref: paymentFormRef,
      amount: {
        price: productDetails.price ?? ERROR_PRICE,
        currency: productDetails.currency,
      },
      stripeMerchantLabel: productDetails.serviceProvider ?? '',
      productTrackingId: 'eurail',
      serviceProviderId: productDetails.serviceProvider ?? '',
      bookingIntentId: eurailPaymentInputPageQueryParams.bookingIntentId,
      userId: eurailPaymentInputPageQueryParams.userId as string,
      touchPointId: eurailPaymentInputPageQueryParams.touchpoint as string,
      decisionId: eurailPaymentInputPageQueryParams.decisionID_PPFI as string,
      shoppingCartId: eurailPaymentInputPageQueryParams.shoppingCartId!,
      // feature flag to disable credit card payments still applies
      allowCreditCardPayment: true,
      onPayment: (response) => {
        const bookingConfirmationPageQueryParams = {
          bookingId: response.id,
        };

        yiluTracking.sendPaymentSuccessfulEvent(eurailPaymentInputPageQueryParams.bookingIntentId);

        navigate({
          pathname: routes.EURAIL_BCP,
          search: paramConverters.getURLSearchQuery(bookingConfirmationPageQueryParams),
        });
      },
      onError(error: Error) {
        throw error;
      },
    };
    return _props;
  }, [paymentFormRef, currentProduct, eurailPaymentInputPageQueryParams, navigate]);
  return paymentInformationFormProps;
}
